import { Switch } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import colors from "../../../theme/colors";

interface ISocialNetwork {
  type: string;
  handleCheck?: any;
  handleSocialNetworkInput?: any;
  previousData?: any;
}

const SocialNetworkContent = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  margin-top: 24px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.colors.offWhite};
  border: 1px solid ${(props) => props.theme.colors.inputBackground};
  justify-content: space-between;

  .switch-button {
    margin-left: 32px;
    @media only screen and (max-width: 1200px) {
      margin-left: 16px;
    }
    @media only screen and (max-width: 768px) {
      margin-left: 8px;
    }
  }

  &.large {
    display: flex;
  }

  &.small {
    display: none;
  }

  @media screen and (max-width: 670px) {
    &.large {
      display: none;
    }

    &.small {
      display: flex;
      flex-direction: column;
    }
  }
`;

const SocialNetworkName = styled.span`
  color: ${(props) => props.theme.colors.title};
  width: 12%;
`;

const SocialNetworkInput = styled.input`
  border: none;
  border: 1px solid ${(props) => props.theme.colors.line};
  width: auto;
  min-width: 65%;
  height: 40px;
  padding: 8px;
  border-radius: 10px;
  color: ${(props) => props.theme.colors.secondary};
  outline: none;

  @media screen and (max-width: 670px) {
    width: 100%;
  }

  ::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
`;

const SocialNetwork: React.FC<ISocialNetwork> = ({
  type,
  handleSocialNetworkInput,
  previousData,
}) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [url, setUrl] = useState<string>("");

  const handleToggle = () => {
    handleSocialNetworkInput(type, !checked);
    setChecked(!checked);
  };

  useEffect(() => {
    if (previousData) {
      setChecked(previousData.active);
      setUrl(previousData.url);
    }
  }, [previousData]);

  return (
    <>
      <SocialNetworkContent className="large">
        <SocialNetworkName>{type}</SocialNetworkName>
        <SocialNetworkInput
          placeholder="http://"
          onChange={(e) =>
            handleSocialNetworkInput(type, checked, e.target.value)
          }
          value={url}
          inputMode="url"
        />
        <Switch
          checked={checked}
          onChange={handleToggle}
          className="switch-button"
          style={{ backgroundColor: checked ? colors.success : colors.border }}
        />
      </SocialNetworkContent>

      <SocialNetworkContent className="small">
        <SwitchContainer>
          <SocialNetworkName>{type}</SocialNetworkName>
          <Switch
            checked={checked}
            onChange={handleToggle}
            className="switch-button"
            style={{ backgroundColor: checked ? colors.success : colors.border }}
          />
        </SwitchContainer>
        <SocialNetworkInput
          placeholder="http://"
          onChange={(e) =>
            handleSocialNetworkInput(type, checked, e.target.value)
          }
          value={url}
          inputMode="url"
        />
      </SocialNetworkContent>
    </>
  );
};

export default SocialNetwork;
